<div class="flex items-center gap-4">
    <mat-checkbox
        [checked]="allChecked()"
        [indeterminate]="partiallyChecked()"
        [disabled]="shownCostCenters().length === 0"
        (change)="toggleAll($event.checked)">
        Odaberi sve
    </mat-checkbox>
    <mat-form-field>
        <mat-label>Tip</mat-label>
        <mat-select
            [value]="selectedTypes()"
            (selectionChange)="selectedTypes.set($event.value)"
            multiple>
            @for (type of distinctTypes(); track type) {
                <mat-option [value]="type">{{ type }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <input
            #ccSearch
            matInput
            placeholder="Pretraži"
            [value]="search()"
            (input)="search.set(ccSearch.value.toLowerCase())" />
    </mat-form-field>
</div>

<cdk-virtual-scroll-viewport itemSize="48" class="h-[30rem]">
    <div
        *cdkVirtualFor="let cc of shownCostCenters()"
        class="h-[48px] flex items-center">
        <mat-checkbox
            class="h-[48px] flex items-center"
            [checked]="(selected() ?? []).includes(cc.masterId)"
            (change)="toggleChecked(cc.masterId)">
            {{ cc.names['hr'] ?? '-' }}
        </mat-checkbox>
    </div>
</cdk-virtual-scroll-viewport>

